"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCCER_TAGS = exports.BASEBALL_TAGS = void 0;

var _ = require("../");

var SOCCER_TAGS = {
  /* hidden system tags */
  "human edited": {
    hidden: true,
    read_only: true
  },
  "human created": {
    hidden: true,
    read_only: true
  },
  "human removed goal": {
    hidden: true,
    read_only: true
  },
  CV: {
    hidden: true,
    read_only: true
  },
  "CV moment": {
    hidden: true,
    read_only: true
  },
  CoachAudio: {
    hidden: true,
    read_only: true
  },
  "coach-audio": {
    hidden: true,
    read_only: true,
    editor: {
      attributes: {
        meta: {
          type: "CoachAudio"
        }
      }
    }
  },
  "Custom upload": {
    hidden: true,
    read_only: true
  },
  FullGameVideo: {
    hidden: true,
    read_only: true
  },
  "full-game": {
    hidden: true,
    read_only: true
  },

  /* automated tags from processing */
  goal: {
    sort: 1,
    title: "goal",
    category: null,
    icon: _.Icon.Type.Soccer,
    editor: {
      categories: ["Description"],
      represents: ["home", "goal"],
      toggles: ["away-goal"]
    }
  },
  key: {
    sort: 1,
    title: "goal",
    category: null,
    icon: _.Icon.Type.Soccer
  },
  "away-goal": {
    sort: 2,
    title: "goal",
    category: null,
    icon: _.Icon.Type.Soccer,
    hidden: true,
    editor: {
      title: "away goal",
      categories: ["Description"],
      represents: ["away", "goal"],
      toggles: ["goal"]
    }
  },
  progression: {
    sort: 3,
    title: "progression",
    category: null,
    editor: {
      categories: ["Description"],
      represents: ["home", "packing"],
      toggles: ["defensive breakdown"]
    }
  },
  packing: {
    sort: 3,
    title: "progression",
    hidden: true,
    category: null
  },
  "defensive breakdown": {
    sort: 3,
    title: "def breakdown",
    hidden: true,
    category: null,
    editor: {
      categories: ["Description"],
      represents: ["away", "packing"],
      toggles: ["progression"]
    }
  },
  box: {
    sort: 4,
    title: "box",
    category: null
  },
  "home-box": {
    sort: 4,
    title: "box",
    category: null,
    editor: {
      categories: ["Description"],
      toggles: ["away-box"]
    }
  },
  "away-box": {
    sort: 4,
    title: "box",
    category: null,
    editor: {
      title: "opponent box",
      categories: ["Description"],
      toggles: ["home-box"]
    }
  },
  dive: {
    sort: 4,
    title: "dive",
    category: "Description",
    editor: {
      categories: ["Description"]
    }
  },
  "touch chain": {
    sort: 7,
    title: "touch chain",
    category: null
  },
  "touch-chain": {
    sort: 7,
    title: "touch chain",
    category: null,
    editor: {
      categories: ["Description"]
    }
  },

  /* Thirds/location */
  offensive: {
    sort: 10,
    title: "att ⅓",
    category: null,
    editor: {
      categories: ["Location"],
      attributes: {
        meta: {
          thirds: ["offensive", "offensive"]
        }
      },
      toggles: ["offensive to middle", "offensive to defensive", "middle", "middle to offensive", "middle to defensive", "defensive", "defensive to offensive", "defensive to middle"],
      required: true
    }
  },
  "offensive to middle": {
    sort: 10.1,
    title: "att ⅓ ⭢ mid ⅓",
    category: null,
    editor: {
      categories: ["Location"],
      attributes: {
        meta: {
          thirds: ["offensive", "middle"]
        }
      },
      toggles: ["offensive", "offensive to defensive", "middle", "middle to offensive", "middle to defensive", "defensive", "defensive to offensive", "defensive to middle"],
      required: true
    }
  },
  "offensive to defensive": {
    sort: 10.2,
    title: "att ⅓ ⭢ def ⅓",
    category: null,
    editor: {
      categories: ["Location"],
      attributes: {
        meta: {
          thirds: ["defensive", "defensive"]
        }
      },
      toggles: ["offensive", "offensive to middle", "middle", "middle to offensive", "middle to defensive", "defensive", "defensive to offensive", "defensive to middle"],
      required: true
    }
  },
  middle: {
    sort: 10.3,
    title: "mid ⅓",
    category: null,
    editor: {
      categories: ["Location"],
      attributes: {
        meta: {
          thirds: ["middle", "middle"]
        }
      },
      toggles: ["offensive", "offensive to middle", "offensive to defensive", "middle to offensive", "middle to defensive", "defensive", "defensive to offensive", "defensive to middle"],
      required: true
    }
  },
  "middle to offensive": {
    sort: 10.4,
    title: "mid ⅓ ⭢ att ⅓",
    category: null,
    editor: {
      categories: ["Location"],
      attributes: {
        meta: {
          thirds: ["middle", "offensive"]
        }
      },
      toggles: ["offensive", "offensive to middle", "offensive to defensive", "middle", "middle to defensive", "defensive", "defensive to offensive", "defensive to middle"],
      required: true
    }
  },
  "middle to defensive": {
    sort: 10.5,
    title: "mid ⅓ ⭢ def ⅓",
    category: null,
    editor: {
      categories: ["Location"],
      attributes: {
        meta: {
          thirds: ["middle", "defensive"]
        }
      },
      toggles: ["offensive", "offensive to middle", "offensive to defensive", "middle", "middle to offensive", "defensive", "defensive to offensive", "defensive to middle"],
      required: true
    }
  },
  defensive: {
    sort: 10.6,
    title: "def ⅓",
    category: null,
    editor: {
      categories: ["Location"],
      attributes: {
        meta: {
          thirds: ["defensive", "defensive"]
        }
      },
      toggles: ["offensive", "offensive to middle", "offensive to defensive", "middle", "middle to offensive", "middle to defensive", "defensive to offensive", "defensive to middle"],
      required: true
    }
  },
  "defensive to middle": {
    sort: 10.7,
    title: "def ⅓ ⭢ mid ⅓",
    category: null,
    editor: {
      categories: ["Location"],
      attributes: {
        meta: {
          thirds: ["defensive", "middle"]
        }
      },
      toggles: ["offensive", "offensive to middle", "offensive to defensive", "middle", "middle to offensive", "middle to defensive", "defensive", "defensive to offensive"],
      required: true
    }
  },
  "defensive to offensive": {
    sort: 10.8,
    title: "def ⅓ ⭢ att ⅓",
    category: null,
    editor: {
      categories: ["Location"],
      attributes: {
        meta: {
          thirds: ["defensive", "offensive"]
        }
      },
      toggles: ["offensive", "offensive to middle", "offensive to defensive", "middle", "middle to offensive", "middle to defensive", "defensive", "defensive to middle"],
      required: true
    }
  },

  /* Cameras */
  tracecam: {
    sort: 500,
    title: "TraceCam",
    category: null,
    read_only: true,
    icon: _.Icon.Type.Multicam,
    background: _.Color.WarningTint2
  },
  "multi-cam": {
    sort: 500,
    title: "Auto switch",
    category: null,
    icon: _.Icon.Type.Multicam,
    background: _.Color.WarningTint2,
    read_only: true
  },
  "phone-*": {
    sort: 500,
    category: null,
    icon: _.Icon.Type.Multicam,
    background: _.Color.WarningTint2,
    read_only: true
  },
  "trace-*": {
    sort: 500,
    category: null,
    icon: _.Icon.Type.TraceSquare,
    background: _.Color.WarningTint2,
    read_only: true
  },
  multicam: {
    sort: 500,
    category: null,
    read_only: true,
    hidden: true
  },

  /* end Cameras */

  /* trace id v2 tags */
  personalization_at_assist: {
    sort: 100,
    title: "assist",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_att_third: {
    sort: 100,
    title: "att ⅓",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_attack_transition: {
    sort: 100,
    title: "att transition",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_attacking_heading: {
    sort: 100,
    title: "att heading",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_attacking_set_piece: {
    sort: 100,
    title: "att set piece",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_counter_attack: {
    sort: 100,
    title: "counter att",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_cross: {
    sort: 100,
    title: "cross",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_def_third: {
    sort: 100,
    title: "def ⅓",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_goal: {
    sort: 100,
    title: "goal",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_mid_third: {
    sort: 100,
    title: "mid ⅓",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_off_ball_movement: {
    sort: 100,
    title: "off the ball",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_one_on_one: {
    sort: 100,
    title: "1v1",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_opponent_box: {
    sort: 100,
    title: "opp box",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_pass: {
    sort: 100,
    title: "pass",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_progression: {
    sort: 100,
    title: "progression",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_shot: {
    sort: 100,
    title: "shot",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_switching_the_play: {
    sort: 100,
    title: "switching the play",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_technique: {
    sort: 100,
    title: "technique",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_touch: {
    sort: 100,
    title: "touch",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_at_touch_chain: {
    sort: 100,
    title: "touch chain",
    category: null,
    editor: {
      categories: ["Attacking"]
    }
  },
  personalization_df_pressing: {
    sort: 100,
    title: "pressing",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_att_third: {
    sort: 100,
    title: "att third",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_away_goal: {
    sort: 100,
    title: "away goal",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_box: {
    sort: 100,
    title: "box",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_def_third: {
    sort: 100,
    title: "def third",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_defense_transition: {
    sort: 100,
    title: "def transition",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_defensive_positioning: {
    sort: 100,
    title: "def position",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_defensive_breakdown: {
    sort: 100,
    title: "def breakdown",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_defensive_heading: {
    sort: 100,
    title: "def heading",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_defensive_set_piece: {
    sort: 100,
    title: "def set piece",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_interception: {
    sort: 100,
    title: "interception",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_mid_third: {
    sort: 100,
    title: "mid third",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_one_on_one_defense: {
    sort: 100,
    title: "1v1 def",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_physicality_: {
    sort: 100,
    title: "physicality",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_reading_the_game: {
    sort: 100,
    title: "reading the game",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_recovery_speed: {
    sort: 100,
    title: "recovery speed",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_df_tackle: {
    sort: 100,
    title: "tackle",
    category: null,
    editor: {
      categories: ["Defense"]
    }
  },
  personalization_gk_agility: {
    sort: 100,
    title: "agility",
    category: null,
    editor: {
      categories: ["Goalkeeping"]
    }
  },
  personalization_gk_att_third: {
    sort: 100,
    title: "att third",
    category: null,
    editor: {
      categories: ["Goalkeeping"]
    }
  },
  personalization_gk_breakaway: {
    sort: 100,
    title: "breakaway",
    category: null,
    editor: {
      categories: ["Goalkeeping"]
    }
  },
  personalization_gk_cross: {
    sort: 100,
    title: "cross",
    category: null,
    editor: {
      categories: ["Goalkeeping"]
    }
  },
  personalization_gk_def_third: {
    sort: 100,
    title: "def third",
    category: null,
    editor: {
      categories: ["Goalkeeping"]
    }
  },
  personalization_gk_distribution: {
    sort: 100,
    title: "distribution",
    category: null,
    editor: {
      categories: ["Goalkeeping"]
    }
  },
  personalization_gk_mid_third: {
    sort: 100,
    title: "mid third",
    category: null,
    editor: {
      categories: ["Goalkeeping"]
    }
  },
  personalization_gk_positioning: {
    sort: 100,
    title: "positioning",
    category: null,
    editor: {
      categories: ["Goalkeeping"]
    }
  },
  personalization_gk_reading_the_game: {
    sort: 100,
    title: "reading the game",
    category: null,
    editor: {
      categories: ["Goalkeeping"]
    }
  },
  personalization_gk_save: {
    sort: 100,
    title: "save",
    category: null,
    editor: {
      categories: ["Goalkeeping"]
    }
  },
  personalization_gk_set_piece: {
    sort: 100,
    title: "set piece",
    category: null,
    editor: {
      categories: ["Goalkeeping"]
    }
  },
  personalization_gk_shot_stopping: {
    sort: 100,
    title: "shot stopping",
    category: null,
    editor: {
      categories: ["Goalkeeping"]
    }
  },

  /* old trace id tags */
  "1v1": {
    sort: 100,
    title: "1v1",
    category: null
  },
  Assist: {
    sort: 100,
    title: "assist",
    category: null
  },
  "Attacking transition": {
    sort: 100,
    title: "att transition",
    category: null
  },
  Breakaways: {
    sort: 100,
    title: "breakaways",
    category: null
  },
  "Counter attack": {
    sort: 100,
    title: "counter att",
    category: null
  },
  Cross: {
    sort: 100,
    title: "cross",
    category: null
  },
  Crosses: {
    sort: 100,
    title: "crosses",
    category: null
  },
  "Defensive transition": {
    sort: 100,
    title: "def transition",
    category: null
  },
  "Dist. from feet": {
    sort: 100,
    title: "dist from feet",
    category: null
  },
  "Dist. from hands": {
    sort: 100,
    title: "dist from hands",
    category: null
  },
  "Final pass": {
    sort: 100,
    title: "final pass",
    category: null
  },
  Heading: {
    sort: 100,
    title: "heading",
    category: null
  },
  Interception: {
    sort: 100,
    title: "interception",
    category: null
  },
  "Off the ball movement": {
    sort: 100,
    title: "off the ball movement",
    category: null
  },
  Pass: {
    sort: 100,
    title: "pass",
    category: null
  },
  Physicality: {
    sort: 100,
    title: "physicality",
    category: null
  },
  Position: {
    sort: 100,
    title: "position",
    category: null
  },
  "Reading the game": {
    sort: 100,
    title: "reading the game",
    category: null
  },
  "Recovery speed": {
    sort: 100,
    title: "recovery speed",
    category: null
  },
  Saves: {
    sort: 100,
    title: "saves",
    category: null
  },
  "Set piece": {
    sort: 100,
    title: "set piece",
    category: null
  },
  Shot: {
    sort: 100,
    title: "shot",
    category: null
  },
  "Switching the play": {
    sort: 100,
    title: "switching the play",
    category: null
  },
  Tackle: {
    sort: 100,
    title: "tackle",
    category: null
  },
  Technique: {
    sort: 100,
    title: "technique",
    category: null
  },
  agility: {
    sort: 100,
    title: "agility",
    category: null
  },
  assist: {
    sort: 100,
    title: "assist",
    category: null
  },
  "attacking transition": {
    sort: 100,
    title: "att transition",
    category: null
  },
  breakaway: {
    sort: 100,
    title: "breakaway",
    category: null
  },
  chain: {
    sort: 100,
    title: "chain",
    category: null
  },
  "counter attack": {
    sort: 100,
    title: "counter att",
    category: null
  },
  cross: {
    sort: 100,
    title: "cross",
    category: null
  },
  "defensive transition": {
    sort: 100,
    title: "def transition",
    category: null
  },
  defensive_decisions: {
    sort: 100,
    title: "def decision",
    category: null
  },
  distribution: {
    sort: 100,
    title: "distribution",
    category: null
  },
  final_pass: {
    sort: 100,
    title: "final pass",
    category: null
  },
  goalkeeper: {
    sort: 100,
    title: "gk",
    category: null
  },
  heading: {
    sort: 100,
    title: "heading",
    category: null
  },
  hit: {
    sort: 100,
    title: "hit",
    category: null
  },
  interception: {
    sort: 100,
    title: "interception",
    category: null
  },
  "off the ball movement": {
    sort: 100,
    title: "off the ball",
    category: null
  },
  pass: {
    sort: 100,
    title: "pass",
    category: null
  },
  position: {
    sort: 100,
    title: "position",
    category: null
  },
  positioning: {
    sort: 100,
    title: "positioning",
    category: null
  },
  "reading the game": {
    sort: 100,
    title: "reading the game",
    category: null
  },
  "recovery speed": {
    sort: 100,
    title: "recovery speed",
    category: null
  },
  save: {
    sort: 100,
    title: "save",
    category: null
  },
  saves: {
    sort: 100,
    title: "saves",
    category: null
  },
  "set piece": {
    sort: 100,
    title: "set piece",
    category: null
  },
  shot: {
    sort: 100,
    title: "shot",
    category: null
  },
  "shot stopping": {
    sort: 100,
    title: "shot stopping",
    category: null
  },
  "switching the play": {
    sort: 100,
    title: "switching the play",
    category: null
  },
  tackle: {
    sort: 100,
    title: "tackle",
    category: null
  },
  technique: {
    sort: 100,
    title: "technique",
    category: null
  }
};
exports.SOCCER_TAGS = SOCCER_TAGS;
var BASEBALL_TAGS = {
  // When, Innings
  "inning-1": {
    sort: 500,
    title: "1st inning",
    category: null,
    read_only: true
  },
  "inning-2": {
    sort: 500,
    title: "2nd inning",
    category: null,
    read_only: true
  },
  "inning-3": {
    sort: 500,
    title: "3rd inning",
    category: null,
    read_only: true
  },
  "inning-4": {
    sort: 500,
    title: "4th inning",
    category: null,
    read_only: true
  },
  "inning-5": {
    sort: 500,
    title: "5th inning",
    category: null,
    read_only: true
  },
  "inning-6": {
    sort: 500,
    title: "6th inning",
    category: null,
    read_only: true
  },
  "inning-7": {
    sort: 500,
    title: "7th inning",
    category: null,
    read_only: true
  },
  "inning-8": {
    sort: 500,
    title: "8th inning",
    category: null,
    read_only: true
  },
  "inning-9": {
    sort: 500,
    title: "9th inning",
    category: null,
    read_only: true
  },
  "inning-10": {
    sort: 500,
    title: "10th inning",
    category: null,
    read_only: true
  },
  "inning-11": {
    sort: 500,
    title: "11th inning",
    category: null,
    read_only: true
  },
  "inning-12": {
    sort: 500,
    title: "12th inning",
    category: null,
    read_only: true
  },
  // Description
  //"home-to-first": "baserunner",
  "at-bat": {
    sort: 100,
    title: "at bat",
    category: null,
    editor: {
      categories: ["Description"],
      title: "at bat"
    }
  },
  hit: {
    sort: 100,
    title: "hit",
    category: null,
    editor: {
      categories: ["Description"],
      title: "hit"
    }
  },
  pitcher: {
    sort: 100,
    title: "pitcher",
    category: null,
    editor: {
      categories: ["Description"],
      title: "pitcher"
    }
  },
  offensive: {
    sort: 100,
    title: "offensive",
    category: null,
    editor: {
      categories: ["Description"],
      title: "offensive",
      toggles: ["defensive"],
      required: true,
      attributes: {
        meta: {
          thirds: ["offensive", "offensive"]
        }
      }
    }
  },
  defensive: {
    sort: 100,
    title: "defensive",
    category: null,
    editor: {
      categories: ["Description"],
      title: "defensive",
      toggles: ["offensive"],
      required: true,
      attributes: {
        meta: {
          thirds: ["defensive", "defensive"]
        }
      }
    }
  },
  defensive_play: {
    sort: 100,
    title: "defensive play",
    category: null,
    editor: {
      categories: ["Description"],
      title: "defensive play"
    }
  },
  single: {
    sort: 100,
    title: "single",
    category: null,
    editor: {
      categories: ["Description"],
      title: "single"
    }
  },
  double: {
    sort: 100,
    title: "double",
    category: null,
    editor: {
      categories: ["Description"],
      title: "double"
    }
  },
  triple: {
    sort: 100,
    title: "triple",
    category: null,
    editor: {
      categories: ["Description"],
      title: "triple"
    }
  },
  homerun: {
    sort: 100,
    title: "home run",
    category: null,
    editor: {
      categories: ["Description"],
      title: "home run"
    }
  },
  double_play: {
    sort: 100,
    title: "double play",
    category: null,
    editor: {
      categories: ["Description"],
      title: "double play"
    }
  },
  triple_play: {
    sort: 100,
    title: "triple play",
    category: null,
    editor: {
      categories: ["Description"],
      title: "triple play"
    }
  },
  strikeout: {
    sort: 100,
    title: "K",
    category: null,
    editor: {
      categories: ["Description"],
      title: "K"
    }
  },
  rbi: {
    sort: 100,
    title: "RBI",
    category: null,
    editor: {
      categories: ["Description"],
      title: "RBI"
    }
  },
  assist: {
    sort: 100,
    title: "assist",
    category: null,
    editor: {
      categories: ["Description"],
      title: "assist"
    }
  },
  steal: {
    sort: 100,
    title: "SB",
    category: null,
    editor: {
      categories: ["Description"],
      title: "SB"
    }
  },
  walk: {
    sort: 100,
    title: "walk",
    category: null,
    editor: {
      categories: ["Description"],
      title: "walk"
    }
  },
  out: {
    sort: 100,
    title: "out",
    category: null,
    editor: {
      categories: ["Description"],
      title: "out"
    }
  },
  hit_by_pitch: {
    sort: 100,
    title: "HBP",
    category: null,
    editor: {
      categories: ["Description"],
      title: "HBP"
    }
  },
  "643_dp": {
    sort: 100,
    title: "6-4-3 DP",
    category: null
  },
  strikeout_looking: {
    sort: 100,
    title: "ꓘ",
    category: null,
    editor: {
      categories: ["Description"],
      title: "ꓘ"
    }
  },
  error: {
    sort: 100,
    title: "Error",
    category: null,
    editor: {
      categories: ["Description"],
      title: "Error"
    }
  },
  bunt: {
    sort: 100,
    title: "Bunt",
    category: null,
    editor: {
      categories: ["Description"],
      title: "Bunt"
    }
  },
  fielders_choice: {
    sort: 100,
    title: "FC",
    category: null,
    editor: {
      categories: ["Description"],
      title: "FC"
    }
  },

  /* Cameras */
  tracecam: {
    sort: 500,
    title: "TraceCam",
    category: null,
    read_only: true,
    icon: _.Icon.Type.Multicam,
    background: _.Color.WarningTint2
  },
  "multi-cam": {
    sort: 500,
    title: "Auto switch",
    category: null,
    read_only: true,
    icon: _.Icon.Type.Multicam,
    background: _.Color.WarningTint2
  },
  "phone-*": {
    sort: 500,
    category: null,
    icon: _.Icon.Type.Multicam,
    background: _.Color.WarningTint2,
    read_only: true
  },
  "trace-*": {
    sort: 500,
    category: null,
    icon: _.Icon.Type.TraceSquare,
    background: _.Color.WarningTint2,
    read_only: true
  },
  multicam: {
    sort: 500,
    category: null,
    read_only: true,
    hidden: true
  },

  /* end Cameras */

  /* TraceID personalization */
  personalization_bb_ht_single: {
    sort: 100,
    title: "single",
    category: null,
    editor: {
      categories: ["Hitting"]
    }
  },
  personalization_bb_ht_double: {
    sort: 100,
    title: "double",
    category: null,
    editor: {
      categories: ["Hitting"]
    }
  },
  personalization_bb_ht_triple: {
    sort: 100,
    title: "triple",
    category: null,
    editor: {
      categories: ["Hitting"]
    }
  },
  personalization_bb_ht_home_run: {
    sort: 100,
    title: "home run",
    category: null,
    editor: {
      categories: ["Hitting"]
    }
  },
  personalization_bb_ht_power: {
    sort: 100,
    title: "power",
    category: null,
    editor: {
      categories: ["Hitting"]
    }
  },
  personalization_bb_ht_two_strike: {
    sort: 100,
    title: "2-strike approach",
    category: null,
    editor: {
      categories: ["Hitting"]
    }
  },
  personalization_bb_ht_speed: {
    sort: 100,
    title: "speed",
    category: null,
    editor: {
      categories: ["Hitting"]
    }
  },
  personalization_bb_ht_rbi: {
    sort: 100,
    title: "RBI",
    category: null,
    editor: {
      categories: ["Hitting"]
    }
  },
  personalization_bb_ht_risp: {
    sort: 100,
    title: "RISP",
    category: null,
    editor: {
      categories: ["Hitting"]
    }
  },
  personalization_bb_ht_out: {
    sort: 100,
    title: "out",
    category: null,
    editor: {
      categories: ["Hitting"]
    }
  },
  personalization_bb_fd_double_play: {
    sort: 100,
    title: "double play",
    category: null,
    editor: {
      categories: ["Fielding"]
    }
  },
  personalization_bb_fd_diving_play: {
    sort: 100,
    title: "diving play",
    category: null,
    editor: {
      categories: ["Fielding"]
    }
  },
  personalization_bb_fd_range: {
    sort: 100,
    title: "range",
    category: null,
    editor: {
      categories: ["Fielding"]
    }
  },
  personalization_bb_fd_backhand: {
    sort: 100,
    title: "backhand",
    category: null,
    editor: {
      categories: ["Fielding"]
    }
  },
  personalization_bb_fd_assist: {
    sort: 100,
    title: "assist",
    category: null,
    editor: {
      categories: ["Fielding"]
    }
  },
  personalization_bb_fd_relay: {
    sort: 100,
    title: "relay",
    category: null,
    editor: {
      categories: ["Fielding"]
    }
  },
  personalization_bb_fd_bunt_defense: {
    sort: 100,
    title: "bunt defense",
    category: null,
    editor: {
      categories: ["Fielding"]
    }
  },
  personalization_bb_fd_great_play: {
    sort: 100,
    title: "great play",
    category: null,
    editor: {
      categories: ["Fielding"]
    }
  },
  personalization_bb_fd_out: {
    sort: 100,
    title: "out",
    category: null,
    editor: {
      categories: ["Fielding"]
    }
  },
  personalization_bb_pi_strikeout: {
    sort: 100,
    title: "K",
    category: null,
    editor: {
      categories: ["Pitching"]
    }
  },
  personalization_bb_pi_fielding: {
    sort: 100,
    title: "fielding the position",
    category: null,
    editor: {
      categories: ["Pitching"]
    }
  },
  personalization_bb_pi_groundout: {
    sort: 100,
    title: "groundout",
    category: null,
    editor: {
      categories: ["Pitching"]
    }
  },
  personalization_bb_pi_flyout: {
    sort: 100,
    title: "flyout",
    category: null,
    editor: {
      categories: ["Pitching"]
    }
  },
  personalization_bb_pi_fastball: {
    sort: 100,
    title: "fastball",
    category: null,
    editor: {
      categories: ["Pitching"]
    }
  },
  personalization_bb_pi_breaking_ball: {
    sort: 100,
    title: "breaking ball",
    category: null,
    editor: {
      categories: ["Pitching"]
    }
  },
  personalization_bb_pi_changeup: {
    sort: 100,
    title: "changeup",
    category: null,
    editor: {
      categories: ["Pitching"]
    }
  },
  personalization_bb_pi_strikeout_looking: {
    sort: 100,
    title: "ꓘ",
    category: null,
    editor: {
      categories: ["Pitching"]
    }
  },
  personalization_bb_fd_error: {
    sort: 100,
    title: "Error",
    category: null,
    editor: {
      categories: ["Fielding"]
    }
  },
  personalization_bb_ht_bunt: {
    sort: 100,
    title: "Bunt",
    category: null,
    editor: {
      categories: ["Hitting"]
    }
  },
  personalization_fielders_bb_ht_choice: {
    sort: 100,
    title: "FC",
    category: null,
    editor: {
      categories: ["Hitting"]
    }
  }
  /* end of TraceID personalization */

};
exports.BASEBALL_TAGS = BASEBALL_TAGS;